module.exports = __webpack_public_path__ + "img/category-new-released.b2731e9e.png";